import { formatDisplayAmount } from '@shared/lib/format';
import { fromTradingNetwork } from '@entities/network';
import { shortenAddress } from '@shared/lib/utils/address';
import type { TokenMetaLookup } from '@entities/token';
import type { Trade } from './trading.schema';

export interface TradeRow {
  id: string;
  pair: string;
  sold: string;
  received: string;
  createdAt: string;
  status: string;
  fromChainId: string;
  toChainId: string | null;
}

/** Lookup is chain-aware: a Solana address must not be lowercased to match (base58 is case-sensitive). */
export function tradeToRow(t: Trade, lookup: TokenMetaLookup): TradeRow {
  const chainId = fromTradingNetwork(t.network) ?? t.network;
  const toNetwork = t.toNetwork ?? t.network;
  const toChainId = fromTradingNetwork(toNetwork) ?? toNetwork;
  const from = lookup(chainId, t.fromToken);
  const to = lookup(toChainId, t.toToken);
  const fromSym = from?.symbol ?? shortenAddress(t.fromToken);
  const toSym = to?.symbol ?? shortenAddress(t.toToken);

  const sold = formatDisplayAmount(t.fromAmount, from?.decimals ?? null);
  const received = formatDisplayAmount(t.toAmount, to?.decimals ?? null);

  return {
    id: t.id,
    pair: `${fromSym}/${toSym}`,
    sold: `${sold.text}${sold.isRaw ? ' (raw)' : ''} ${fromSym}`,
    received: `${received.text}${received.isRaw ? ' (raw)' : ''} ${toSym}`,
    createdAt: t.createdAt,
    status: t.txHash ? 'completed' : 'failed',
    fromChainId: chainId,
    toChainId: t.toNetwork ? toChainId : null,
  };
}
